// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".col-xs-16.feedback-notes-title{margin-bottom:25px;padding-left:0}.feedback-container{height:330px;margin-bottom:20px;overflow-y:auto;padding-top:10px;width:100%;-ms-overflow-style:none}.feedback-container::-webkit-scrollbar{display:none}h2{font-size:25px}.feedback-section{margin-top:30px}", ""]);
// Exports
module.exports = exports;
